import {SpanIcon} from '@mazraeapp/react_icon_kit';
import classNames from 'classnames';
import {useNavigate} from 'react-router-dom';
import './style.css';

interface CustomHeaderProps {
  title?: string;
  preIcon?: string;
  backRoute?: string;
  isActiveRightIcon?: boolean;
  isScrolling?: boolean;
  canScroll?: boolean;
  preComponent?: () => JSX.Element;
  postComponent?: () => JSX.Element;
  onClick?: () => void;
  titleClass?: string;
  justifyFlex?: string;
  sticky?: boolean;
}

const CustomHeader = ({
  title,
  isActiveRightIcon,
  preIcon,
  backRoute,
  isScrolling,
  canScroll = false,
  titleClass,
  preComponent,
  postComponent = () => <div></div>,
  onClick,
  justifyFlex = 'justify-between',
  sticky = false, // Default to false
}: CustomHeaderProps) => {
  const navigate = useNavigate();

  return (
    <header
      className={classNames(
        `flex text-md border-b shadow-sm text-gray-800 Home-Main-Header bg-white px-3 w-full ${justifyFlex} items-center`,
        {
          'Home-Main-Header-close ': isScrolling && canScroll,
          'Home-Main-Header-open': !isScrolling && canScroll,
          'Home-Main-Header-constant': !canScroll,
          'sticky top-0 z-10': sticky, // Apply sticky only when prop is true
        },
      )}
    >
      {preComponent?.()}

      {isActiveRightIcon && (
        <SpanIcon
          className={`${preIcon} text-[25px] text-gray-700`}
          onClick={() =>
            backRoute ? navigate(backRoute) : onClick ? onClick() : navigate(-1)
          }
        />
      )}
      <div
        className={classNames(
          'font-[500] gray-800 line-clamp-1 min-w-[100px] text-center',
          titleClass,
        )}
      >
        {title}
      </div>
      {postComponent?.()}
    </header>
  );
};

export default CustomHeader;
